<template>
  <v-card flat class="borda">
    <v-card-title class="headline ma-2 ml-0">Taxas para vendas online</v-card-title>
    <v-card-text class="black--text">
      <span>Confira as taxas por meio de pagamento selecionado:</span>
      <br />
      <span>
        <strong>Boleto:</strong> R$ 2,79
      </span>
      <br />
      <span>
        <strong>Cartão de Crédito:</strong> 2,49%
      </span>
      <p></p>
      <span>Taxas de intermediação para pagamentos online com Meu Clube</span>
      <br />
      <span>
        <strong>Taxa de intermediação para Planos de Associados e Cobranças:</strong>
        {{taxas.plano_pagamento_online_taxa}}%
      </span>
      <br />
      <span>
        <strong>Taxa de intermediação para Eventos</strong>
        <span class="caption">(Ingressos e Atividades):</span>
        {{taxas.plano_pagamento_online_evento_taxa}}%
      </span>
      <br />
      <br />
      <span>Exemplo de aplicação</span>
      <p></p>
      <span>
        <strong>Venda de ingresso</strong>
      </span>
      <br />
      <span>Vendido por: R$ 100,00</span>
      <br />
      <span>- Taxa boleto: R$ 2,79</span>
      <br />
      <span>- Taxa intermediação: {{taxas.plano_pagamento_online_taxa}}%</span>
      <p></p>
      <span>
        <strong>Você receberá:</strong>
        {{valor}}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => {
    return {
      taxas: [],
      valor: "",
    };
  },
  mounted() {
    this.getTaxas();
  },
  methods: {
    getTaxas() {
      Api.get(`/clubes/taxas`)
        .then((response) => {
          if (response.data) {
            this.taxas = response.data;
            let calc = "0.0" + this.taxas.plano_pagamento_online_taxa;
            this.valor = 100 - 100 * calc;
            this.valor = this.floatToMoney2(this.valor - 2.79);
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    floatToMoney2(money) {
      money = money.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });

      return money;
    },
  },
};
</script>

